<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Accounts.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> {{$lang.Accounts.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="$lang.Accounts.PlaceholderEnterName"
                          v-model="form.name.value"
                          :size="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtEmail"><small class="text-danger">*</small> {{$lang.Accounts.LabelEmail}}:</label>
          <div class="input-group">
            <b-form-input type="email"
                          :placeholder="$lang.Accounts.PlaceholderEnterEmail"
                          v-model="form.email.value"
                          :size="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"
                          autocomplete="false"
                          @blur.native="onCheckEmail"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtPhone"><small v-show="form.cellPhone.required" class="text-danger">*</small> {{$lang.Accounts.LabelMobilePhone}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPhone"
                          :placeholder="$lang.Accounts.PlaceholderMobilePhone"
                          v-model="form.cellPhone.value"
                          :size="form.cellPhone.maxlength"
                          :required="form.cellPhone.required"
                          :state="form.cellPhone.state"
                          v-mask="['(##) # ####-####']"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCPF"><small v-show="form.cpf.required" class="text-danger">*</small> {{$lang.Accounts.LabelCPF}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPhone"
                          :placeholder="$lang.Accounts.PlaceholderCPF"
                          v-model="form.cpf.value"
                          :size="form.cpf.maxlength"
                          :required="form.cpf.required"
                          :state="form.cpf.state"
                          v-mask="['###.###.###-##']"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Accounts.LabelGroup}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.groupID.value" :options="form.groupID.options" class="mb-3" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxAnalyst"><small v-show="form.isAnalyst.required" class="text-danger">*</small> {{$lang.Accounts.LabelResponsible}}</label>
          <div class="input-group">
            <b-form-select v-model="form.isAnalyst.value"
                          :options="form.isAnalyst.options"
                          :state="form.isAnalyst.state"
                          class="mb-3"
                          name="cbxAnalyst">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
              <option :value="true">{{$lang.Common.Yes}}</option>
              <option :value="false">{{$lang.Common.No}}</option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small v-show="form.expertID.required" class="text-danger">*</small> {{$lang.Accounts.LabelExpert}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.expertID.value" :options="form.expertID.options" class="mb-3" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small v-if="form.mechanicalWorkshopID.required" class="text-danger">*</small> {{$lang.Accounts.LabelMechanicalWorkshop}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.mechanicalWorkshopID.value" :options="form.mechanicalWorkshopID.options" class="mb-3" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-1">
          <h5 class="text-third"><i class="fa fa-lock"></i> {{$lang.Accounts.AccessPasswords}}</h5>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtPassword"><small class="text-info">*</small> {{$lang.Accounts.LabelPassword}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password"
                          :placeholder="$lang.Accounts.PlaceholderEnterPassword"
                          v-model="form.password.value"
                          :size="form.password.maxlength"
                          :required="form.password.required"
                          :state="form.password.state"
                          autocomplete="new-password"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtConfirmation"><small class="text-info">*</small> {{$lang.Accounts.LabelConfirmation}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password"
                          :placeholder="$lang.Accounts.PlaceholderConfirmationPassword"
                          v-model="form.confirmation.value"
                          :size="form.confirmation.maxlength"
                          :required="form.confirmation.required"
                          :state="form.confirmation.state"
                          autocomplete="new-password"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <small class="text-third"><i class="fa fa-info-circle"></i> {{$lang.Accounts.PasswordOnlyNewRegistration}}</small>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[$lang.Accounts.DataTable.Name,
                       $lang.Accounts.DataTable.Group,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.group.name" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import Account from './account.js'

export default Account
</script>



// WEBPACK FOOTER //
// src/views/private/access/account/account.vue